var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgLogoWhite = function SvgLogoWhite(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 171.59 44.65",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-white-demo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.22,37.28V5.13H27.5V8.58H12.12V19.44H26.06v3.45H12.12V37.27H8.22Z",
    transform: "translate(-7.64 -5.13)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.75,5.13h3.89V26.42a11.22,11.22,0,0,1-1.55,5.88,10.85,10.85,0,0,1-4.36,4.07,13.9,13.9,0,0,1-6.59,1.48,14,14,0,0,1-6.59-1.48,10.85,10.85,0,0,1-4.36-4.07,11.22,11.22,0,0,1-1.55-5.88V5.13h3.89v21a8.34,8.34,0,0,0,1,4.18,7.31,7.31,0,0,0,3,2.87,9.49,9.49,0,0,0,4.61,1,9.67,9.67,0,0,0,4.62-1,7.31,7.31,0,0,0,3-2.87,8.33,8.33,0,0,0,1-4.18Z",
    transform: "translate(-7.64 -5.13)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.17,8.58V5.13H86.28V8.58H76.17v28.7H72.28V8.58Z",
    transform: "translate(-7.64 -5.13)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.9,5.13h3.89V26.42a11.22,11.22,0,0,1-1.55,5.88,10.85,10.85,0,0,1-4.36,4.07,15.41,15.41,0,0,1-13.18,0,10.85,10.85,0,0,1-4.36-4.07,11.22,11.22,0,0,1-1.55-5.88V5.13h3.89v21a8.34,8.34,0,0,0,1,4.18,7.31,7.31,0,0,0,3,2.87,9.49,9.49,0,0,0,4.61,1,9.67,9.67,0,0,0,4.62-1,7.31,7.31,0,0,0,3-2.87,8.33,8.33,0,0,0,1-4.18Z",
    transform: "translate(-7.64 -5.13)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.08,37.28V5.13h10.86a13.25,13.25,0,0,1,6.19,1.28,8.26,8.26,0,0,1,3.58,3.51A10.76,10.76,0,0,1,143.87,15a10.7,10.7,0,0,1-1.16,5,8.14,8.14,0,0,1-3.56,3.45A13.3,13.3,0,0,1,133,24.73h-8.79V21.21h8.67a9.72,9.72,0,0,0,4.15-.75,4.79,4.79,0,0,0,2.29-2.14A7.14,7.14,0,0,0,140,15a7.51,7.51,0,0,0-.72-3.38A4.93,4.93,0,0,0,137,9.38a9.4,9.4,0,0,0-4.19-.79H126v28.7h-3.9Zm15.13-14.44,7.91,14.44H140.6l-7.79-14.44Z",
    transform: "translate(-7.64 -5.13)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.83,37.28V5.13h19.4V8.58H152.72V19.44h14.5v3.45h-14.5V33.82h15.76v3.45H148.83Z",
    transform: "translate(-7.64 -5.13)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89,41.82h1l2.46,6h.08l2.46-6h1v7.23h-.82V43.56h-.07l-2.26,5.49H11L8.77,43.56H8.71v5.49H7.89Z",
    transform: "translate(-7.64 -5.13)",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.08,49h-.92l2.65-7.23h.9L32.36,49h-.92L29.28,43h-.06Zm.34-2.82h3.7V47h-3.7Z",
    transform: "translate(-7.64 -5.13)",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3,41.82v7.23h-.85l-3.94-5.67h-.07v5.67h-.88V41.82h.85l4,5.69h.07V41.82Z",
    transform: "translate(-7.64 -5.13)",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.41,49h-.92l2.65-7.23H64L66.69,49h-.92L63.61,43h-.06Zm.34-2.82h3.7V47h-3.7Z",
    transform: "translate(-7.64 -5.13)",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.53,44.08a2.53,2.53,0,0,0-.31-.64,2.07,2.07,0,0,0-.45-.48,2,2,0,0,0-.59-.31,2.36,2.36,0,0,0-.72-.11,2.15,2.15,0,0,0-1.17.33,2.33,2.33,0,0,0-.84,1,4.18,4.18,0,0,0,0,3.16,2.19,2.19,0,0,0,2.06,1.31,2.21,2.21,0,0,0,1.1-.27,1.91,1.91,0,0,0,.74-.75,2.35,2.35,0,0,0,.27-1.15l.27.06H80.72v-.78h2.75v.78a3.07,3.07,0,0,1-.38,1.55,2.62,2.62,0,0,1-1,1,3.41,3.41,0,0,1-3.22-.09,3.07,3.07,0,0,1-1.13-1.28,4.48,4.48,0,0,1-.4-2,4.89,4.89,0,0,1,.23-1.54,3.32,3.32,0,0,1,.65-1.17,2.9,2.9,0,0,1,1-.74,3.13,3.13,0,0,1,1.27-.26,3.38,3.38,0,0,1,1.07.17,3.05,3.05,0,0,1,.89.48,2.86,2.86,0,0,1,.65.74,3.08,3.08,0,0,1,.36,1h-.89Z",
    transform: "translate(-7.64 -5.13)",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.05,49V41.81h4.36v.78H95.92V45h3.26v.78H95.92v2.46h3.54v.78H95.05Z",
    transform: "translate(-7.64 -5.13)",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.89,41.82h1l2.46,6h.08l2.46-6h1v7.23h-.82V43.56h-.07l-2.26,5.49H114l-2.26-5.49h-.07v5.49h-.82V41.82Z",
    transform: "translate(-7.64 -5.13)",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.81,49V41.81h4.36v.78h-3.49V45h3.26v.78h-3.26v2.46h3.54v.78h-4.41Z",
    transform: "translate(-7.64 -5.13)",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.37,41.82v7.23h-.85l-3.94-5.67h-.07v5.67h-.88V41.82h.85l4,5.69h.07V41.82Z",
    transform: "translate(-7.64 -5.13)",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.68,42.59v-.78h5.42v.78h-2.27V49H165V42.59Z",
    transform: "translate(-7.64 -5.13)",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.52,45.47a1.06,1.06,0,0,0-.79.48,1.9,1.9,0,0,0-.29,1,2,2,0,0,0,.14.79,1.27,1.27,0,0,0,.4.53.92.92,0,0,0,.58.19.81.81,0,0,0,.47-.13,1.12,1.12,0,0,0,.32-.33,1.9,1.9,0,0,0,.21-.43c.05-.15.1-.29.13-.41l.19-.69a5.15,5.15,0,0,1,.2-.59,2.87,2.87,0,0,1,.34-.62,1.82,1.82,0,0,1,.54-.49,1.57,1.57,0,0,1,.81-.19,1.83,1.83,0,0,1,1,.29,2,2,0,0,1,.7.84,3.54,3.54,0,0,1,0,2.59,2,2,0,0,1-.66.83,1.92,1.92,0,0,1-1,.34v-.85a1.06,1.06,0,0,0,.64-.26,1.4,1.4,0,0,0,.38-.58,2.56,2.56,0,0,0,.13-.75,2.3,2.3,0,0,0-.15-.85,1.41,1.41,0,0,0-.43-.6,1,1,0,0,0-.65-.22.77.77,0,0,0-.55.19,1.44,1.44,0,0,0-.35.5,5.84,5.84,0,0,0-.24.67l-.24.83a3.26,3.26,0,0,1-.66,1.26,1.46,1.46,0,0,1-1.12.46,1.66,1.66,0,0,1-1-.32,2.05,2.05,0,0,1-.66-.84,2.83,2.83,0,0,1-.23-1.18A2.72,2.72,0,0,1,172,45.8a2.08,2.08,0,0,1,.64-.81,1.59,1.59,0,0,1,.92-.31Z",
    transform: "translate(-7.64 -5.13)",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.63,43.26l-6.8,0,0-4.1h.73l0,3.28,2.3,0,0-3.07h.73l0,3.07,2.31,0,0-3.33h.73Z",
    transform: "translate(-7.64 -5.13)",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.67,37.67l-6.8-.05,0-2.3a2.79,2.79,0,0,1,.28-1.31,1.7,1.7,0,0,1,.75-.75A2.35,2.35,0,0,1,174,33a2.27,2.27,0,0,1,1.06.25,1.71,1.71,0,0,1,.72.76,2.89,2.89,0,0,1,.26,1.3v1.86h-.74V35.36a2.18,2.18,0,0,0-.15-.88,1,1,0,0,0-.45-.49,1.68,1.68,0,0,0-.7-.16,1.66,1.66,0,0,0-.72.15,1.11,1.11,0,0,0-.48.48,2,2,0,0,0-.17.89V36.8l6.07,0Zm-3-3.22,3.07-1.65v1l-3.07,1.63Z",
    transform: "translate(-7.64 -5.13)",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.91,31.53l5.74-2v-.08l-5.71-2.06v-.86l6.78,2.54v.85l-6.82,2.45Z",
    transform: "translate(-7.64 -5.13)",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,24.66l6.8.05v.82l-6.8-.05Z",
    transform: "translate(-7.64 -5.13)",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.13,17.55v.82a1.77,1.77,0,0,0-.63.25,1.75,1.75,0,0,0-.74,1,2.32,2.32,0,0,0-.1.65,2.13,2.13,0,0,0,.3,1.12,2.23,2.23,0,0,0,.91.8,3.32,3.32,0,0,0,1.49.3,3.48,3.48,0,0,0,1.49-.28,2.14,2.14,0,0,0,.93-.79,2,2,0,0,0,.32-1.12,2.32,2.32,0,0,0-.09-.65,1.87,1.87,0,0,0-.27-.57,1.71,1.71,0,0,0-.45-.44,1.81,1.81,0,0,0-.62-.26v-.82a2.53,2.53,0,0,1,.93.35,2.42,2.42,0,0,1,.69.62,3,3,0,0,1,.13,3.33,3,3,0,0,1-1.22,1.06,4.26,4.26,0,0,1-1.86.38,4.12,4.12,0,0,1-1.86-.4,2.91,2.91,0,0,1-1.2-1.07,2.79,2.79,0,0,1-.41-1.55,2.92,2.92,0,0,1,.6-1.79,2.75,2.75,0,0,1,.7-.61A3.12,3.12,0,0,1,174.13,17.55Z",
    transform: "translate(-7.64 -5.13)",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.82,16.26l-6.8-.05,0-4.1h.73l0,3.28,2.3,0,0-3.07h.73l0,3.07,2.31,0,0-3.33h.73Z",
    transform: "translate(-7.64 -5.13)",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.78,6.91a1.06,1.06,0,0,0-.79.48,1.9,1.9,0,0,0-.29,1,2,2,0,0,0,.14.79,1.35,1.35,0,0,0,.4.53.92.92,0,0,0,.58.19.81.81,0,0,0,.47-.13,1.12,1.12,0,0,0,.32-.33,1.9,1.9,0,0,0,.21-.43c.05-.15.1-.29.13-.41l.19-.69a5.15,5.15,0,0,1,.2-.59,2.5,2.5,0,0,1,.34-.62,1.7,1.7,0,0,1,.54-.49,1.57,1.57,0,0,1,.81-.19,1.83,1.83,0,0,1,1,.29,2,2,0,0,1,.7.84A3,3,0,0,1,179,8.52a3,3,0,0,1-.24,1.26,2,2,0,0,1-.66.83,1.92,1.92,0,0,1-1,.34V10.1a1.06,1.06,0,0,0,.64-.26,1.4,1.4,0,0,0,.38-.58,2.56,2.56,0,0,0,.13-.75,2.3,2.3,0,0,0-.15-.85,1.41,1.41,0,0,0-.43-.6,1,1,0,0,0-.65-.22.77.77,0,0,0-.55.19,1.44,1.44,0,0,0-.35.5,5.84,5.84,0,0,0-.24.67l-.25.83a3.26,3.26,0,0,1-.66,1.26,1.46,1.46,0,0,1-1.12.46,1.66,1.66,0,0,1-1-.32,2.05,2.05,0,0,1-.66-.84A2.83,2.83,0,0,1,172,8.41a2.72,2.72,0,0,1,.24-1.17,2.08,2.08,0,0,1,.64-.81,1.59,1.59,0,0,1,.92-.31Z",
    transform: "translate(-7.64 -5.13)",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-white.d6f3724f0c4583fb12e7146303ab56e0.svg";